import "@googlemaps/extended-component-library/overlay_layout.js";
import { APIProvider } from "@vis.gl/react-google-maps";
import React, {
	forwardRef,
	useEffect,
	useImperativeHandle,
	useRef,
	useState,
} from "react";
import {
	PlacePicker,
	PlaceResult,
} from "@googlemaps/extended-component-library/react";
import { CONFIG } from "../../../config";
import { getGoogleApiKey } from "../../../lib/OptionListApi";

type Props = {
	onAddressChange: Function;
	country: string;
};

const PlaceAutocomplete = forwardRef(
	({ onAddressChange, country }: Props, ref) => {
		const pickerRef = useRef<any>(null);
		const [place, setPlace] = useState<
			google.maps.places.PlaceAutocompleteElement | undefined
		>(undefined);
		const [tesst, setTest] = useState<string>("");

		const [apiKey, setApiKey] = useState<string>("");

		const getApiKey = async () => {
			const result = await getGoogleApiKey();
			const decryptedKey = result?.value ?? "";
			setApiKey(decryptedKey);
		};

		const buildFullAddress = (p: any): string => {
			if (p.gmpStructuredAddress) {
				// 2) new SDK
				const a = p.gmpStructuredAddress;
				return [
					a.building,
					[a.streetNumber, a.route].filter(Boolean).join(" "),
					a.locality,
				]
					.filter(Boolean)
					.join(", ");
			}

			if (p.addressComponents) {
				// 3) legacy

				const get = (t: string) =>
					p.addressComponents!.find((c: any) => c.types.includes(t))
						?.longText || "";
				return [
					get("point_of_interest"),
					[get("street_number"), get("route")]
						.filter(Boolean)
						.join(" "),
					get("locality") || get("administrative_area_level_1"),
				]
					.filter(Boolean)
					.join(", ");
			}

			return p.displayName?.text || p.name || ""; // 4) fallback
		};

		useEffect(() => {
			getApiKey();
		}, [apiKey]);

		const onPlaceChange = (event: any | undefined) => {
			const newPlace = event?.target?.value || pickerRef.current?.value;
			if (!newPlace) {
				setPlace(undefined);
				// onAddressChange({ lat: undefined, lng: undefined, label: "" });
				return;
			} else {
				const label = buildFullAddress(newPlace);
				setPlace(newPlace);
				setTest(label);
				onAddressChange({
					lat: newPlace.location?.lat(),
					lng: newPlace.location?.lng(),
					label: label ?? newPlace.formattedAddress,
				});
			}
		};

		useImperativeHandle(ref, () => ({
			handleClear: () => {
				pickerRef.current?.handleClear(); // Call the handleClear method of the PlacePicker
				setPlace(undefined); // Optionally reset the place state
			},
			setInputText: (text: string) => {
				pickerRef.current.inputElement.value = text;
				pickerRef.current.handleInput({ target: { value: text } });
			},
		}));

		if (apiKey === "") {
			return <div>Loading...</div>;
		}

		return (
			<div>
				<APIProvider
					solutionChannel="GMP_devsite_samples_v3_rgmcollegepicker"
					// apiKey={CONFIG?.GOOGLE_MAPS_API_KEY}
					apiKey={apiKey ?? ""}
					version="beta"
				>
					<PlacePicker
						ref={pickerRef}
						forMap="gmap"
						placeholder="Search"
						country={[country]}
						onPlaceChange={onPlaceChange}
					/>
				</APIProvider>
			</div>
		);
	}
);

export default PlaceAutocomplete;
